import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../../../../components/NavBarAdmin";
import Table from "../../../../Layout/Table/Table";
import Select from "../../../../Layout/Forms/Select";
import { Puff } from "react-loading-icons";

import "./EventList.css";

import VenuesApprovalRequests from "../VenuesApprovalRequests";
import { Grid } from "../../../../Layout/Grid/GridView";

const EventListCards = () => {
  const [isLoading, setIsLoading] = useState(false);
  let params = useParams();
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("nightspot");
  const gridRef = useRef();



  const requestEventList = async (filter = "") => {
    setIsLoading(true);
    document.title = "Events list | Nightspot Dashboard";
    let info = await VenuesApprovalRequests.getEventList(params, filter);
    if (info && info.status) {
      setData(info.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    requestEventList(filter);
  }, [filter]);

  const handleChangeFilter = (e) => {
    setFilter(e.target.value);
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const DetailsBtnColumn = (e) => {
    return (
      <div>
        <Link
          className="btn btn-primary"
          to={`/my/admin/venues/${e.data.id_venues}/events/${e.data.id}/details`}
        >
          <i className="fa-solid fa-circle-info"></i>&nbsp; Detalhes
        </Link>
      </div>
    );
  };

  const StatusColumn = (e) => {
    return (
      <div className={`status-column ${e.data.status.toString().toLowerCase()}`}>
        {e.data.status}
      </div>
    );
  };



  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-xs-12 col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row align-items-center mb-4">
                  <div className="col-8">
                    <h2 className="dashboard-h2 m-0">Lista de eventos</h2>
                  </div>
                  <div className="col-4">
                    <Select
                      label="Origem dos Eventos"
                      name="filter"
                      value={filter}
                      variant="simple-no-label"
                      onChangeOption={handleChangeFilter}
                      options={[
                        { label: "Nightspot Events", value: "nightspot" },
                        { label: "Todos", value: "" },
                      ]}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <Grid
                      ref={gridRef}
                      rows={data}
                      cols={[
                        { hide: true, field: "id" },
                        {
                          headerName: "",
                          field: "image",
                          cellRenderer: (params) => {
                            return (
                              <div className="text-center">
                                <img
                                  src={params.data.image}
                                  className="img-fluid"
                                  style={{ height: "25px", width: "auto" }}
                                />
                              </div>
                            );
                          },
                        },
                        { headerName: "Venue", field: "venue_name" },
                        { headerName: "Nome", field: "name" },
                        { headerName: "Data", field: "date" },
                        { headerName: "Tickets", field: "tickets_enabled" },
                        { headerName: "Tables", field: "tables_enabled" },

                        {
                          headerName: "Detalhes",
                          cellClass: "actions-button-cell",
                          cellRenderer: DetailsBtnColumn,
                        },
                        {
                          headerName: "Estado",
                          field: "status",
                          cellRenderer: StatusColumn,
                        },
                      ]}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default EventListCards;
